import React from "react";
import SelectStepTemplate from "../../../template/SelectStepTemplate";
import useGetMateriais, {
  buildOutrosTecidos,
} from "../../../template/UseGetMateriais";
import { TipoDivergenciaComponent } from "../../../TiposDeDivergencias";
import SaldoFiscalTecidoObservacaoStep from "./SaldoFiscalTecidoObservacaoStep";
import TipoDivergenciasInfoKey from "../../../TipoDivergenciasInfoKey.";

const SaldoFiscalTecido: TipoDivergenciaComponent = ({ onSetStep, onBack }) => {
  const { loading, materiais } = useGetMateriais(
    TipoDivergenciasInfoKey.TECIDO
  );
  const newMateriais = [...materiais, buildOutrosTecidos()];

  const stepNumber = "2";
  const stepSubTitle = "Selecione o material";
  const stepTitle = "Qual material será ajustado?";
  return (
    <SelectStepTemplate
      data={newMateriais}
      loading={loading}
      nextStepComponent={
        SaldoFiscalTecidoObservacaoStep as TipoDivergenciaComponent
      }
      onBack={onBack}
      onSetStep={onSetStep}
      payloadKey="materiais"
      stepNumber={stepNumber}
      stepSubTitle={stepSubTitle}
      stepTitle={stepTitle}
    />
  );
};

export default SaldoFiscalTecido;
